export default {
  // table
  application_table_name: 'Application Name',
  application_table_installation_date: 'Installation Date',
  application_table_status_enable: 'Enabled',
  application_table_status_disable: 'Disabled',
  application_confirm_content: 'Application Name: {name}',
  application_confirm_delete_title: 'Are you sure you want to delete this application?',
  application_confirm_enable_title: 'Are you sure you want to enable this application?',
  application_confirm_disable_title: 'Are you sure you want to disable this application?',
  // user
  application_menu: 'Application Access',
  application_menu_add: 'Add Application Access',
  application_menu_edit: 'Edit Application Access',
  application_menu_detail: 'Application Access Details',
  // form
  application_form_name: 'Application Name',
  application_form_name_placeholder: 'Please enter application name',
  application_form_status: 'Application Status',
  application_form_status_placeholder: 'Please select status',
  application_form_description: 'Application Description',
  application_form_description_placeholder: 'Please enter application description',
  application_form_icon: 'Application Icon',
  application_form_bind_username: 'Bind User',
  application_form_bind_username_placeholder: 'Please select a user to bind',
  application_form_app_id_placeholder: 'Please enter appId',
  application_form_app_secret_placeholder: 'Please enter appSecret',
  application_form_auto_generation_placeholder: 'Automatically generated by the system',
  application_form_installTime: 'Installation Time',
  application_form_installTime_placeholder: 'Please select installation time',
  // detail
  application_detail_basic_info: 'Basic Information',
  application_detail_affiliation_name: 'Affiliation Name',
  application_detail_status: 'Status',
  application_detail_access_user: 'Access User',
  application_detail_access_time: 'Access Time',
  application_detail_descrption: 'Description',
  application_detail_path: 'Path',
  application_detail_bindUser: 'Bind User',
  application_detail_auth: 'Application Credentials',
};
